module.exports = __webpack_public_path__ + "img/adaptive-innovation.963b907e.svg";